/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

import styled, { keyframes, css } from "styled-components";

export const SHADOW_WIDTH = 360;

const slide = keyframes`
  0% {
    left: -${SHADOW_WIDTH}px;
  }
  100% {
    left: 100%;
  }
`;

export const Shadow = styled.div<{ fallbackAnimation?: boolean }>`
  position: absolute;
  bottom: 0;
  top: 0;
  background: var(--mode-gradient-skeleton-bg) no-repeat center;
  z-index: 3;
  width: ${SHADOW_WIDTH}px;
  left: -${SHADOW_WIDTH}px;

  ${({ fallbackAnimation }) =>
    fallbackAnimation &&
    css`
      animation: ${slide} 2s linear infinite;
    `};
`;

export type LayoutProps = {
  margin?: string;
  padding?: string;
  $width?: string;
};

export const Layout = styled.div<LayoutProps>`
  position: relative;
  overflow: hidden;
  ${({ margin }) => margin && `margin: ${margin}`};
  ${({ padding }) => padding && `padding: ${padding}`};
  ${({ $width }) => $width && `width: ${$width}`};

  box-sizing: border-box;
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;

/**
 * Some utility components to help quickly set up skeletons
 */
export const Square = styled(
  ({
    height,
    width,
    fixedWidth,
    margin,
    background,
    padding,
    className,
    ...props
  }) => <div {...props} className={className?.concat(" square-skeleton")} />
)`
  overflow: hidden;
  background-color: ${({ background }) =>
    background || "var(--mode-bg-neutral-weak)"};
  height: ${({ height }) => height};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};

  ${({ fixedWidth, width }) =>
    fixedWidth
      ? css`
          width: ${width};
        `
      : css`
          width: 100%;
          max-width: ${width};
          min-width: 0;
        `};
`;

export const Card = styled(Square)`
  background-color: ${({ background }) =>
    background || "var(--mode-bg-neutral-weakest)"};
`;

export const Circle = styled(Square)`
  border-radius: 100%;
`;
